module.exports = __webpack_public_path__ + "static/img/3.c7463d9a.png";